import { formatGtfsStartDate } from "./liveTripTiming.js";

/**
 * A reverse-geocoded location is only a useful substitute once a successful
 * live-trip response has explicitly said that it cannot name a stop. In
 * particular, an absent response may simply still be loading (or have failed),
 * and must not spend a reverse-geocoding request.
 */
export function hasAffirmativelyUnknownVehicleStop(vehicleUpdate) {
  if (!vehicleUpdate || typeof vehicleUpdate !== "object") {
    return false;
  }

  const { update } = vehicleUpdate;
  return Boolean(update && typeof update === "object" && update.stopId == null);
}

export function getSelectedVehicleDetailsApiPath(selectedItem) {
  if (!selectedItem || selectedItem.type !== "vehicle") {
    return null;
  }

  if (selectedItem.id == null || String(selectedItem.id).length === 0)
    return null;
  const query = new URLSearchParams();
  if (selectedItem.trip_id) query.set("trip_id", selectedItem.trip_id);
  if (selectedItem.startDate) query.set("start_date", selectedItem.startDate);
  if (selectedItem.startTime) query.set("start_time", selectedItem.startTime);
  const suffix = query.size ? `?${query}` : "";
  return `/api/vehicle-details/${encodeURIComponent(selectedItem.id)}${suffix}`;
}

export function getSelectedVehicleTripHref(selectedItem) {
  if (
    !selectedItem ||
    selectedItem.type !== "vehicle" ||
    !selectedItem.trip_id
  ) {
    return null;
  }

  const tripId = encodeURIComponent(selectedItem.trip_id);
  const date = formatGtfsStartDate(selectedItem.startDate);
  const query = new URLSearchParams({ from: "map" });

  if (date) {
    query.set("date", date);
  }

  return `/trip/${tripId}?${query.toString()}`;
}
